import type { menu as Fr } from '../fr/menu';

/** « menu » in English — typed on the French: a missing sentence does not compile. */
export const menu: typeof Fr = {
  secAuComptoir: 'At the counter',
  secMesVoitures: 'My vehicles',
  secMesClients: 'My customers',
  secLArgent: 'Money',
  secMesChiffres: 'My figures',
  secReglages: 'Settings',
  aujourdHui: 'Today',
  voituresLibres: 'Available vehicles',
  nouvelleLocation: 'New rental',
  mesLocations: 'My rentals',
  contrats: 'Rental agreements',
  planning: 'Planning board',
  aValider: 'Approvals',
  mesVoitures: 'My vehicles',
  entretien: 'Maintenance',
  vidange: 'Oil change',
  plaquettes: 'Brake pads',
  pneus: 'Tyres',
  revision: 'Service',
  courroie: 'Timing belt',
  batterie: 'Battery',
  controleTechnique: 'Technical inspection',
  assurances: 'Insurance',
  amendes: 'Fines',
  accidents: 'Accidents',
  clients: 'Customers',
  caisse: 'Cash register',
  dettes: 'Outstanding',
  depenses: 'Petty cash',
  caisseExtra: 'Extra cash',
  banque: 'Bank',
  cautions: 'Deposits',
  factures: 'Invoices',
  tresoreriePrevision: 'Cash flow & forecast',
  analyses: 'Analytics',
  journalDActivite: 'Audit log',
  notes: 'Notes',
  guideDuLogiciel: 'User guide',
  parametres: 'Settings',
  utilisateursEtDroits: 'Users & permissions',
  supprimerUneFiche: 'Delete a record',
  mesTaches: 'My tasks',
  libres: 'Available',
  nouvelle: 'New',
  plus: 'More',
};
